import * as styles from "./ParagraphHighlightedTextArea.module.scss";

import { graphql } from "gatsby";
import React from "react";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphHighlightedTextAreaProps {
	heading: string;
	htmlText: string;
	iconSrc: string;
	iconAlt: string;
}

export const getParagraphHighlightedTextAreaProps = ({
	field_heading,
	field_text: { value: text },
	relationships: { field_icon },
}: Queries.ParagraphHighlightedTextAreaDataFragment): ParagraphHighlightedTextAreaProps => ({
	heading: field_heading,
	htmlText: text,
	iconSrc: field_icon?.field_media_image?.uri,
	iconAlt: field_icon?.field_media_image?.alt,
});
export const ParagraphHighlightedTextArea: React.FC<
	ParagraphHighlightedTextAreaProps
> = ({ heading, htmlText, iconSrc, iconAlt }) => {
	return (
		<WrappedSection
			sectionName="ParagraphHighlightedTextAreaProps"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<div className={styles.paragraphhighlightedtextareainner}>
				{iconSrc && iconAlt && (
					<ProcessedImage
						className={styles.image}
						src={iconSrc}
						alt={iconAlt}
						dimensions="200x200"
						width={200}
						height={200}
						loading={"lazy"}
					/>
				)}
				<div className={styles.titlewrapper}>
					<h2 className={styles.title}>{heading}</h2>
				</div>
				<div
					className={styles.text}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{ __html: htmlText }}
				/>
			</div>
		</WrappedSection>
	);
};

export default ParagraphHighlightedTextArea;

export const fragment = graphql`
    fragment ParagraphHighlightedTextAreaData on paragraph__highlighted_text_area {
        __typename
        id
        field_heading
        field_text {
            value
        }
        relationships {
            field_icon {
                ...MediaImageData
            }
        }
    }
`;
